import React from "react";
import "../css/table.css";
import TableSchema from "../models/TableSchema";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const makeReadableTableHeaders = (
  tableSchema: TableSchema,
  columns: string[],
  onSortColumn: (columnName: string | undefined, isSortUp: boolean) => void,
  sortedColumnName: string | undefined,
  isSortedUp: boolean
): JSX.Element[] => {
  const tableColumns: JSX.Element[] = [];

  columns.forEach((column) => {
    let icon: "sort-up" | "sort-down" | "sort" = isSortedUp ? "sort-up" : "sort-down";
    if (!sortedColumnName || sortedColumnName !== column) {
      icon = "sort";
    }

    tableColumns.push(
      <td className="table-head p-0 m-0" key={`td_column_${column}`}>
        <div className="d-flex flex-row">
          <button
            type="button"
            className="btn btn-sm btn-link p-0 ml-1 text-left text-white"
            style={{ color: "#1e1f1d" }}
            onClick={(): void => {
              if (!sortedColumnName) {
                onSortColumn(column, true);
              } else {
                if (sortedColumnName && isSortedUp) {
                  onSortColumn(column, false);
                } else {
                  onSortColumn(undefined, true);
                }
              }
            }}
          >
            {tableSchema[column].readableName}
          </button>

          <FontAwesomeIcon
            onClick={(): void => {
              if (!sortedColumnName) {
                onSortColumn(column, true);
              } else {
                if (sortedColumnName && isSortedUp) {
                  onSortColumn(column, false);
                } else {
                  onSortColumn(undefined, true);
                }
              }
            }}
            icon={icon}
            className="ml-2 mr-1 mt-1 text-white"
          />
        </div>
      </td>
    );
  });

  return tableColumns;
};

interface TableBodyProps<T> {
  tableSchema: TableSchema;
  allOrderedColumns: string[];
  visibleColumns: string[];
  items: T[];
  renderRow(orderedColumns: string[], item: T): JSX.Element;

  onSortColumn(columnName: string | undefined, isSortUp: boolean): void;
  sortedColumnName?: string;
  isSortedUp: boolean;
}

function TableBody<T>({
  // columns
  tableSchema,
  allOrderedColumns,
  visibleColumns,
  // items
  items,
  renderRow,
  onSortColumn,
  sortedColumnName,
  isSortedUp,
}: TableBodyProps<T>): JSX.Element {
  const orderedColumns = allOrderedColumns.filter((column) => visibleColumns.includes(column));

  const tableHeaders = makeReadableTableHeaders(
    tableSchema,
    orderedColumns,
    onSortColumn,
    sortedColumnName,
    isSortedUp
  );
  const tableRows = items.map((item) => renderRow(orderedColumns, item));

  return (
    <div className="row flex-grow-1 overflow-auto">
      <table className="table table-bordered table-sm m-0">
        <thead>
          <tr>{tableHeaders}</tr>
        </thead>
        <tbody className="overflow-auto">{tableRows}</tbody>
      </table>
    </div>
  );
}
export default TableBody;
